<template>
  <div class="home">
    <div class="container">
      <h1 class="title">
        {{ $t("homepage_title") }}
      </h1>
      <p>
         {{ $t("homepage_description") }}
      </p>
      <SearchJobs />
    </div>
  </div>
</template>

<script>
import SearchJobs from '@/components/SearchJobs'
export default {
  name: 'v-home',
  components: {
    SearchJobs
  }
}
</script>
<style lang="scss" scoped>
.home {
  .search-jobs {
    margin-top: 6rem;
  }
}
</style>
